if (!customElements.get('fp-review-carousel')) {
  customElements.define('fp-review-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const track = this.querySelector('.fp-selected-reviews__track');
      const buttons = [...this.querySelectorAll('[data-direction]')];
      const update = () => {
        buttons[0].disabled = track.scrollLeft < 2;
        buttons[1].disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      this.querySelector('.fp-selected-reviews__controls').hidden = false;
      buttons.forEach(button => button.addEventListener('click', () => {
        const card = track.querySelector('article');
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
        track.scrollBy({left: step * Number(button.dataset.direction), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }));
      track.addEventListener('scroll', update, {passive:true});
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      update();
    }
    disconnectedCallback() { this.observer?.disconnect(); this.ready = false; }
  });
}
